module.exports = __webpack_public_path__ + "img/coral-gas.14c5be22.png";